var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.hide)?_c('div',{staticClass:"panel10 middle flex-row",staticStyle:{"margin-bottom":"1px"}},[_c('el-page-header',{staticStyle:{"flex":"1"},attrs:{"content":_vm.title},on:{"back":_vm.goBack}}),_vm._t("button")],2):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }